module.exports = __webpack_public_path__ + "img/0-11.78822f8a.gif";